import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBasket2"><Path d="M8 3.5L6.09571 8.26074M16 3.5L17.9043 8.26074M21.5 8.5L19.5 20.5H4.5L2.5 8.5H21.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBasket2;
